import { object, string, array, number } from "yup"

import Presenter from "./views/Presenter"
import BusinessInfo from "./views/BusinessInfo"
// import OtherInfo from "./views/OtherInfo"
import Shareholders from "./views/Shareholders"

export default [
  {
    id: "business_info",
    component: BusinessInfo,
    initialValues: {
      suffix: "",
      preferred_name1: "",
      preferred_name2: "",
      preferred_name3: "",
      preferred_name4: "",
      business_nature: "",
      category: "",
      address: "",
      country: "",
      state: "",
      city: "",
    },
    validationSchema: object().shape({
      suffix: string().required("Required"),
      preferred_name1: string().required("Provide a sample Preferred Name 1"),
      preferred_name2: string().required("Provide a sample Preferred Name 2"),
      preferred_name3: string().required("Provide a sample Preferred Name 3"),
      preferred_name4: string().required("Provide a sample Preferred Name 4"),
      business_nature: string().required("Required"),
      category: string().required("Required"),
      address: string().required("Required"),
      country: string().required("Provide your country"),
      city: string()
        .matches(/^[a-zA-Z\s]*$/, "City is invalid")
        .required("Indicate city where business is located"),
      state: string().required(
        "Kindly indicate state where business is located"
      ),
    }),
    actionLabel: "Next",
    onAction: async (sectionValues, formValues) => {
      const fields = {
        suffix: sectionValues.suffix,
        preferred_name1: sectionValues.preferred_name1,
        preferred_name2: sectionValues.preferred_name2,
        preferred_name3: sectionValues.preferred_name3,
        preferred_name4: sectionValues.preferred_name4,
        business_nature: sectionValues.business_nature,
        category: parseInt(sectionValues.category),
        address: sectionValues.address,
        country: parseInt(sectionValues.country),
        state: sectionValues.state,
        city: sectionValues.city,
      }

      await fetch(
        `${process.env.DIY_BASE_URL}/api/order/v1/CompanyIncorporation/step1`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            Authorization: `Token ${localStorage.getItem("dd_token")}`,
          },
          body: JSON.stringify(fields),
        }
      )
        .then((response) => {
          if (!response.ok) {
            console.log(response)

            throw new Error("HTTP status " + response.statusText)
          }
          return response.json()
        })
        .then((response) => {
          localStorage.setItem("orderReference", response.orderReference)
        })
        .catch((error) => {
          console.error(error)
          throw new Error("An error occurred in the form")
          // return []
        })
    },
  },
  {
    id: "shareholder_info",
    component: Shareholders,
    initialValues: {
      suffix: "",
    },
    actionLabel: "Next",
  },
  {
    id: "presenter_info",
    component: Presenter,
    initialValues: {
      company_secretary: "",
      secretary_type: "",
      secretary_firstname: "",
      secretary_surname: "",
      secretary_address: "",
      secretary_country: "",
      secretary_state: "",
      secretary_city: "",
      secretary_email: "",
      secretary_phone: "",
      identity_number: "",
      identity_type: "",
      identity: "",
    },
    validationSchema: object().shape({
      company_secretary: string().required("Required"),
    }),
    actionLabel: "Confirm",
    onAction: async (sectionValues, formValues) => {
      const fields = {
        company_secretary: sectionValues.company_secretary,
        secretary_type: sectionValues.secretary_type,
        secretary_firstname: sectionValues.secretary_firstname,
        secretary_surname: sectionValues.secretary_surname,
        secretary_address: sectionValues.secretary_address,
        secretary_country: sectionValues.secretary_country,
        secretary_state: sectionValues.secretary_state,
        secretary_city: sectionValues.secretary_city,
        secretary_email: sectionValues.secretary_email,
        secretary_phone: sectionValues.secretary_phone,
        identity_number: sectionValues.identity_number,
        identity_type: sectionValues.identity_type,
        identity: {
          name: sectionValues.identity,
        },
      }
      await fetch(
        `${
          process.env.DIY_BASE_URL
        }/api/order/v1/CompanyIncorporation/step4?order-ref=${localStorage.getItem(
          "orderReference"
        )}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            Authorization: `Token ${localStorage.getItem("dd_token")}`,
          },
          body: JSON.stringify(fields),
        }
      )
        .then((response) => {
          if (!response.ok) {
            console.log(response)

            throw new Error("HTTP status " + response.statusText)
          }
          return response.json()
        })
        .then((response) => {
          // console.log(response)
        })
        .catch((error) => {
          console.error(error)
          throw new Error("An error occurred in the form")
          // return []
        })
    },
  },
]
